<template>
  <DetailsListItemLocationChip
    :code="code"
    :short-display-name="name"
    :icon-url="iconUrl"
    :name="name"
    :theme="theme"
    location-type="water"
    @click="handleClick"
  />
</template>

<script>
import { mapGetters } from "vuex";
import { MODULE_PREFIX_HOME } from "@/store";
import { EVENT_ACTIONS } from "@/common/constants/analytics";
import { hasGrdAccess } from "@/services/user/user.service";

const EMITTED_ACTIONS = {
  AFTER_CLICK: "after-click",
};

export default {
  name: "DetailsListItemWaterChip",
  components: {
    DetailsListItemLocationChip: () =>
      import("@/components/common/details/DetailsListItemLocationChip.vue"),
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    code: {
      type: String,
      required: true,
    },
    theme: {
      type: String,
    },
    analyticsCategory: {
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      selectorPanel: MODULE_PREFIX_HOME + "selectorPanel",
      detailsSidebar: MODULE_PREFIX_HOME + "detailsSidebar",
    }),
    iconUrl() {
      return require("@/assets/images/icons/water-icon.png");
    },
  },
  methods: {
    handleClick() {
      this.detailsSidebar.visible = false;
      this.selectorPanel.selected = hasGrdAccess()
        ? "grdCountries"
        : "stability";
      this.selectorPanel.visible = true;
      this.selectorPanel.selectedData = {
        code: this.code,
      };

      if (this.analyticsCategory) {
        this.handlePageTrackerEvent(
          this.analyticsCategory,
          EVENT_ACTIONS.clicked,
          `${this.name}`
        );
      }

      this.$emit(EMITTED_ACTIONS.AFTER_CLICK);
    },
  },
};
</script>
